import employeeAxios from '../../../axios/employee'
import { enqueueSnackbar } from '../../actions'
import { saveFileFromResponse } from '../../../helpers'
import {
  EXPORT_SALARY_START,
  EXPORT_SALARY_SUCCESS,
  EXPORT_SALARY_FAILED
} from '../actionTypes/actionTypes'

export const exportSalary = filterOptions => {
  return dispatch => {
    dispatch(exportSalaryStart())
    employeeAxios
      .get('salary/export', {
        params: filterOptions,
        responseType: 'blob'
      })
      .then(response => {
        if (response.status === 200) {
          saveFileFromResponse(response)
          dispatch(exportSalarySuccess())
          dispatch(
            enqueueSnackbar({
              message: 'Export Salary Success',
              options: { variant: 'success' }
            })
          )
        }
      })
      .catch(err => {
        console.log(err, { ...err })
        dispatch(exportSalaryFailed())
        dispatch(
          enqueueSnackbar({
            message: 'Export Salary Failed',
            options: { variant: 'error' }
          })
        )
      })
  }
}

const exportSalaryStart = () => {
  return {
    type: EXPORT_SALARY_START
  }
}

const exportSalarySuccess = () => {
  return {
    type: EXPORT_SALARY_SUCCESS
  }
}

const exportSalaryFailed = () => {
  return {
    type: EXPORT_SALARY_FAILED
  }
}
